import { render, staticRenderFns } from "./ViewJobListing.vue?vue&type=template&id=045e2616"
import script from "./ViewJobListing.vue?vue&type=script&lang=js"
export * from "./ViewJobListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045e2616')) {
      api.createRecord('045e2616', component.options)
    } else {
      api.reload('045e2616', component.options)
    }
    module.hot.accept("./ViewJobListing.vue?vue&type=template&id=045e2616", function () {
      api.rerender('045e2616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/views/ViewJobListing.vue"
export default component.exports